/**
 * Turn 3: one clinical-simulation decision point (public diagnostic).
 * Exportable for Lane A mount. Uses existing Maria beat content.
 */
import React, { useRef, useState } from 'react';
import type { SimulationBeatResult } from './types';
import { getLocalSimulationBeat } from './api';
import { buildSimulationBeatResult, simulationFeedback } from './laneCPolicy';
import { DiagnosticQuestion, PamReadThenContinue } from './components/DiagnosticQuestion';

export interface SimulationBeatTurnProps {
  onComplete: (result: SimulationBeatResult) => void;
}

export const SimulationBeatTurn: React.FC<SimulationBeatTurnProps> = ({ onComplete }) => {
  const beat = getLocalSimulationBeat();
  const [feedback, setFeedback] = useState<string | null>(null);
  const resultRef = useRef<SimulationBeatResult | null>(null);

  const submit = (decisionId: string) => {
    if (feedback) return;
    resultRef.current = buildSimulationBeatResult({ scenarioId: beat.scenarioId, decisionId, llmUsed: false });
    setFeedback(simulationFeedback(decisionId, beat));
  };

  const finish = () => {
    if (resultRef.current) onComplete(resultRef.current);
  };

  return (
    <section data-testid="public-diagnostic-simulation-beat">
      <DiagnosticQuestion
        id={`public-diag-sim-${beat.scenarioId}`}
        category="Clinical simulation"
        stem={beat.stem}
        choices={beat.decisions.map((d) => ({ id: d.id, text: d.label }))}
        locked={feedback !== null}
        submitting={false}
        onSubmit={submit}
      >
        {feedback && (
          <div data-testid="simulation-beat-feedback" data-llm-used="false">
            <PamReadThenContinue read={feedback} onContinue={finish} />
          </div>
        )}
      </DiagnosticQuestion>
    </section>
  );
};

export default SimulationBeatTurn;
